class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
  
      this.input = this.querySelector('#Search-blog');
      this.predictiveSearchResults = this.querySelector('#predictive-search-blog');
  
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
    }
  
    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      fetch(`/search?q=${searchTerm}&type=article`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('blog-posts');
          console.log(resultsMarkup);
          const buttonElement = document.createElement('button');
          buttonElement.type = 'submit'; // Set the button type to "submit"
          buttonElement.textContent = `Search for "${searchTerm}"`; // Set the button text
          
          if (resultsMarkup){
            const resultsMarkup_blog = new DOMParser().parseFromString(text, 'text/html').querySelector('blog-posts').innerHTML;
            console.log(resultsMarkup);
            this.predictiveSearchResults.innerHTML = resultsMarkup_blog;
            this.predictiveSearchResults.appendChild(buttonElement);
          }else{
            this.predictiveSearchResults.innerHTML = '<p>No result found</p>';
          }
          //blog-posts
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
  
    open() {
      this.predictiveSearchResults.style.display = 'block';
    }
  
    close() {
      this.predictiveSearchResults.style.display = 'none';
    }
  
    debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }
  
  customElements.define('predictive-search-blog', PredictiveSearch);
  